import React from 'react'
import Anime from 'react-anime'

export default () => (
  <svg
    viewBox="-5 -5 75 75"
    version="1"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    style={{
      marginLeft: '3px',
      transform: 'rotate(45deg)'
    }}
    strokeMiterlimit="1"
    width="50px"
  >
    <Anime
      duration={3000}
      delay={(e, i) => i * 70}
      loop={true}
      direction="alternate"
      opacity={[0.7, 1]}
    >
      <g>
        <Anime delay={150} translateX={[0, -4]} translateY={[0, -4]}>
          <path
            d="M23 4a4 4 0 0 0-4-4h-8C5 0 0 5 0 11v8a4 4 0 0 0 4 4h19V4z"
            fill="#ff4439"
          />
        </Anime>
      </g>
      <g>
        <Anime delay={200} translateX={[0, 4]} translateY={[0, -4]}>
          <path
            d="M53 23a4 4 0 0 0 3-4v-8c0-6-5-11-11-11h-7a4 4 0 0 0-4 4v19h19z"
            fill="#ff4439"
          />
        </Anime>
      </g>
      <g>
        <Anime delay={150} translateX={[0, 4]} translateY={[0, 4]}>
          <path
            d="M34 53a4 4 0 0 0 4 3h7c6 0 11-5 11-11v-7a4 4 0 0 0-3-4H34v19z"
            fill="#ff4439"
          />
        </Anime>
      </g>
      <g>
        <Anime translateX={[0, -4]} delay={200} translateY={[0, 4]}>
          <path
            d="M4 34a4 4 0 0 0-4 4v7c0 6 5 11 11 11h8a4 4 0 0 0 4-3V34H4z"
            fill="#ff4439"
          />
        </Anime>
      </g>
    </Anime>
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/kreuz.js